export default "__VITE_ASSET__635ae734__"